const init = {
    loading: false,
    audioRequest: null,
    audioResponse: undefined,
    isSaved: false
  };
  
  export const audioPreview = (state = init, action) => {
    switch (action.type) {
      
      case "FETCH_ROAD_SPECIAL_EVENT_AUDIO_SUCCESS":
        return { ...state, loading: false, audioResponse: action.payload };
      case "FETCH_ROAD_SPECIAL_EVENT_AUDIO_FAILURE":
        return { ...state, loading: false, error: action.payload };
      case "FETCH_ROAD_SPECIAL_EVENT_AUDIO_START":
        return { ...state, loading: true };
      default:
        return state;
    }
  };
  